module.exports = __webpack_public_path__ + "img/default-user.9af42ba9.png";